import { IButtonStyles, ITextFieldStyles, mergeStyleSets, IChoiceGroupStyles } from "@fluentui/react";

export const sessionStyles = {
  buttonStyles: {
    root: {
      background: "var(--colorBrandBackgroundSelected)", // background color
      borderRadius: 10
    },
    rootHovered: {
      background: "var(--colorBrandBackgroundHover)" // hover background color
    },
    rootPressed: {
      background: "var(--colorBrandBackgroundPressed)" // pressed background color
    },
    rootDisabled: {
      background: "var(--colorNeutralBackgroundDisabled)" // disabled background color
    }
  } as IButtonStyles,
  textFieldStyles: {
    fieldGroup: {
      backgroundColor: "#f3f6fa",
      borderRadius: "12px",
      border: "1px solid #e1e4ea",
      "&:hover": {
        borderColor: "var(--colorBrandBackgroundSelected)"
      },
      "&::after": {
        borderColor: "var(--colorBrandBackgroundSelected)",
        borderRadius: "12px"
      }
    },
    field: {
      backgroundColor: "#f3f6fa",
      border: "1px solid #e1e4ea",
      borderRadius: "12px",
      boxShadow: "0 1px 4px rgba(0,0,0,0.03)"
    }
  } as Partial<ITextFieldStyles>,
  readonlyTextFieldStyles: {
    fieldGroup: {
      backgroundColor: "#f5f5f5",
      border: "1px solid #e1e4ea",
      borderRadius: "12px",
      "&:hover": {
        borderColor: "var(--colorBrandBackgroundSelected)"
      },
      "&::after": {
        borderColor: "var(--colorBrandBackgroundSelected)",
        borderRadius: "12px"
      }
    },
    field: {
      cursor: "default"
    }
  } as Partial<ITextFieldStyles>,
  choiceGroupStyles: {
    label: { display: "inline" },
    flexContainer: {
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
      marginLeft: "12px"
    },
    root: {
      selectors: {
        ".ms-ChoiceFieldLabel": {
          fontWeight: "700 !important"
        }
      }
    }
  } as IChoiceGroupStyles
};

export const sessionClassNames = mergeStyleSets({
  flexRowWithGap: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    paddingBottom: "20px"
  },
  flexColumnWithGap: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  scaledChoiceFieldStyle: {
    transform: "scale(0.8)",
    transformOrigin: "top left"
  },
  modalLabelStyles: {
    fontSize: "16px",
    fontWeight: "600"
  },
  panelButtonStyles: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    paddingTop: "20px"
  },
  saveSessionButtonStyles: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px"
  },
  sessionsTableStyles: {
    width: "100%",
    paddingTop: "10px"
  }
});
